import { headerShipToAddressStyles as styles } from "@insite/content-library/Widgets/Common/HeaderShipToAddress";
import { colorStrings } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.titleIcon = {
    ...styles.titleIcon,
    color: colorStrings.commonGlobalGray02,
    css: css`
        font-weight: 400;
    `,
};

styles.titleTypography = {
    ...styles.titleTypography,
    color: colorStrings.commonGlobalGray02,
    weight: 700,
    css: css`
        margin-left: 10px;
        font-weight: 700;
    `,
    mergeCss: true,
};
